export enum BackendAPI {
	base = "/api",
	activateUser = "./api/users/activate",
	calculateOrderPrice = "./api/orders/calculatePrice",
	cancelOrder = "./api/orders/orders",
	client = "./api/clients/client/",
	clients = "./api/clients/clients",
	exportToXls = "./api/exportToXLS",
	forgotPassword = "./api/users/forgotPassword",
	getMessages = "./api/messages/messages",
	order = "./api/orders/orders",
	orderHeaders = "./api/orders/orderHeaders",
	orderHistory = "./api/orders/history",
	orderMaterial = "./api/orders/materials",
	orderMaterialForAdvertiser = "./api/orders/materialsForAdvertiser",
	orderSpaceAvailability = "./api/orders/spaceAvailability",
	orderConfirmationPDF = "./api/orders/confirmation",
	paymentForm = "./api/payments/getpaymentform",
	postMessage = "./api/messages/messages",
	registerUser = "./api/users/profiles",
	resetPassword = "./api/users/resetPassword",
	staticDataCountries = "./api/staticData/countries",
	staticDataDatesForPackageAndPlacement = "./api/staticData/datesForPackageAndPlacement",
	staticDataGalleryImages = "./api/staticData/galleryImages",
	staticDataGalleryImagesForPackageAndPlacement = "./api/staticData/galleryImagesForPackageAndPlacement",
	staticDataPackages = "./api/staticData/packages",
	staticDataPackagesForPlacement = "./api/staticData/packagesForPlacement",
	staticDataPlacementCategories = "./api/staticData/placementCategories",
	staticDataServices = "./api/staticData/services",
	staticDataStylesForPackageAndPlacement = "./api/staticData/stylesForPackageAndPlacement",
	staticDataValidPackagesAndPlacements = "./api/staticData/validPackagesAndPlacements",
	staticResourcePackageInfopanel = "./branding/products/info-popups",
	systemConfiguration = "./api/system/configuration",
	systemLog = "./api/system/log",
	updateOrder = "./api/orders/orders",
	userLogin = "./api/users/login",
	userProfiles = "./api/users/profiles",
	authenticateWithToken = `./api/externalPlanner/authenticateWithToken?plannerToken=`,
	orderStoreStatus = "./api/orders/storeStatus",
}
